'use client';

import { ArrowRight, Phone } from 'lucide-react';
import { useState } from 'react';
import { Popup } from '@/components/popup/Popup';
import { Button } from '@/components/ui/button';
import { components } from '@/types/strapi';

interface CTAProps {
	CTAs: components['schemas']['SharedButtonComponent'][];
}

export const CTA = ({ CTAs }: CTAProps) => {
	const [openPopups, setOpenPopups] = useState<Record<number, boolean>>({});

	const handlePopupToggle = (id: number, isOpen: boolean) => {
		setOpenPopups(prev => ({ ...prev, [id]: isOpen }));
	};

	return (
		<div className="flex flex-wrap gap-4">
			{CTAs?.map(cta => {
				const isPhone = /^[\d\s+-]+$/.test(cta.text || '');

				return cta.URL ? (
					<Button
						key={cta.id}
						size="lg"
						variant={cta.variant}
						asChild>
						<a href={cta.URL} target={cta.target}>
							<span className="flex items-center gap-2">
								{isPhone && <Phone className="h-4 w-4" />}
								{cta.text}
								{!isPhone && cta.variant === 'primary' && (
									<ArrowRight className="h-4 w-4" />
								)}
							</span>
						</a>
					</Button>
				) : (
					<div key={cta.id}>
						{cta.popup && (
							<Popup
								popup={cta.popup}
								buttonText={cta.text || ''}
								buttonVariant={cta.variant}
								isOpen={openPopups[cta.id || 0] || false}
								setIsOpen={isOpen =>
									handlePopupToggle(cta.id || 0, isOpen)
								}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
};
